import axios from "axios";

export default {
  state: {
    tags: null,
  },
  mutations: {
    setTags(state, tags) {
      state.tags = tags;
    },
  },
  getters: {
    communityTags(state) {
      if (state.tags !== null) {
        return state.tags.filter((tag) => tag.community_tag);
      }
      return [];
    },
    resourceTags(state) {
      if (state.tags !== null) {
        return state.tags.filter((tag) => tag.resource_tag);
      }
      return [];
    },
    matchingTag(state) {
      return (tag) => {
        if (state.tags !== null) {
          let matchFunction = null;
          if (typeof tag === "string") {
            matchFunction = (t) => t.name.toLowerCase() === tag.toLowerCase();
          } else if (typeof tag === "object") {
            matchFunction = (t) => t.id === tag.id;
          } else if (typeof tag === "number") {
            matchFunction = (t) => t.id === tag;
          }
          if (matchFunction) {
            let matchingTags = state.tags.filter(matchFunction);
            if (matchingTags.length) {
              return matchingTags[0];
            }
          }
        }
      };
    },
    colourForTag(state, getters) {
      return (tag) => {
        const matchingTag = getters.matchingTag(tag);
        if (matchingTag) {
          return matchingTag.colour;
        }
        return "#777777";
      };
    },
  },
  actions: {
    async fetchTags({ commit, state }) {
      if (state.tags === null) {
        let response = await axios.get("/api/tags");
        commit("setTags", response.data.tags);
      }
    },
  },
};
